/**
 * Updates the href attribute of anchor elements based on the provided language links.
 *
 * @param {Object<string, string>} lang - An object containing language keys and their corresponding URLs.
 * @param {string} lang.ru - The URL for the Russian language.
 * @param {string} lang.uk - The URL for the Ukrainian language.
 * @param {string} lang.en - The URL for the English language.
 * @param {string} lang.current - The current language key (ignored in processing).
 *
 * @example
 * const lang = {
 *   "ru": "/collections/2/",
 *   "uk": "/uk/collections/2/",
 *   "en": "/en/collections/2/",
 *   "current": "uk"
 * };
 * langLinks(lang);
 */
const updateLangLinks = (lang) => {
  Object.entries(lang).forEach(([key, value]) => {
    if (key !== "current") {
      const links = document.querySelectorAll(`a[data-lang="${key}"]`)
      links.forEach((link) => {
        link.setAttribute("href", value)
      })
    }
  })
}
/**
 * Updates the search params and pathname of language links based on current URL.
 * Handles language prefix in pathname and preserves search params after navigation.
 */
export const updateLangLinksSearchParams = () => {
  const links = document.querySelectorAll("a[data-lang]")
  const currentUrl = new URL(window.location)
  const basePath = currentUrl.pathname.replace(/^\/(uk|en)(\/|$)/, "/")

  links.forEach((link) => {
    let linkLang = link.getAttribute("data-lang")
    const linkLangUrl = new URL(link.href)
    linkLang = linkLang === "ru" ? "" : linkLang

    linkLangUrl.pathname = linkLang + basePath
    linkLangUrl.search = currentUrl.search

    link.setAttribute("href", linkLangUrl.toString())
  })
}
export default updateLangLinks
